var AppSubmissionComponent = (function () {
    function AppSubmissionComponent() {
    }
    return AppSubmissionComponent;
}());
export { AppSubmissionComponent };



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/submission/app-submission.component.ts.pre-build-optimizer.js